export const getSignatureDeadline = (seconds = 25) =>
  Math.floor(Date.now() / 1000) + seconds;
